<template>
  <div>
    <el-collapse v-model="activeNames" style="border: none;">
      <el-collapse-item title="订单查询" name="1" style="margin: 0px 20px 0 20px;padding: 20px;">
        <el-form :inline="true" label-width="110px" style="padding: 20px 0 0 0; border-top: 1px solid #f1f1f1;">
          <el-form-item label="订单状态选择:" style="margin-left: 10px;">
            <el-select v-model="orderstate" filterable placeholder="请选择订单状态" @change="orderstatechange">
              <el-option
                v-for="item in orderstatelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单日期:" style="margin-left: 10px;">
            <el-date-picker
              v-model="byorderdate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用户手机:" style="margin-left: 10px;">
            <el-select
              v-model="wxuseropenid"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="getwxuser">
              <el-option
                v-for="item in wxuserlist"
                :key="item.openid"
                :label="item.phone"
                :value="item.openid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="display: flex;flex-flow: row;">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="queryall">查询订单</el-button>
          <el-button style="margin-left: 10px;" type="success" icon="el-icon-download" @click="outputorder">导出订单详情</el-button>
          <!--
            <el-button style="margin-top: 10px; margin-left: 10px;" @click="importset">导入配置</el-button>
          <el-upload
            ref="upload"
            style="margin-top: 10px; margin-left: 10px;"
            action="/"
            :show-file-list="false"
            :on-change="importExcel"
            :auto-upload="false">
            <el-button
              icon="el-icon-upload"
              type="primary">
              导入配送单
            </el-button>
          </el-upload>
          -->
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-tabs v-model="activeName" type="card" style="margin: 0 40px 0 40px;">
      <el-tab-pane label="分销订单视图" name="orderview">
        <div id="mymainChart" class="card"></div>
      </el-tab-pane>
      <el-tab-pane label="分销订单信息" name="orderinfo">
        <div style="margin-top: 10px;width:100%;display: flex;flex-flow:row;justify-content: center;align-items: center;">
          <el-pagination
            ref="elpage"
            @size-change="sizechange"
            @current-change="curpagehange"
            :current-page="currentPage"
            :page-sizes="[size]"
            :page-size=size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
        <el-table
          stripe
          id="fxorderdataid"
          :data="orderdata"
          ref="multipleTable">
          <el-table-column
            prop="order_no"
            width = "200px"
            label="订单编号">
          </el-table-column>
          <el-table-column
            prop="state_id"
            label="订单状态">
            <template slot-scope="scope">
              <div v-if="scope.row.state_id === 1">待付款</div>
              <div v-if="scope.row.state_id === 2">已付款待发货</div>
              <div v-if="scope.row.state_id === 3">已发货待确认</div>
              <div v-if="scope.row.state_id === 4">已确认</div>
              <div v-if="scope.row.state_id === 5">已评价</div>
              <div v-if="scope.row.state_id === 6">已分账</div>
              <div v-if="scope.row.state_id === 9">已取消</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ownphone"
            label="联系方式">
          </el-table-column>
          <el-table-column
            prop="count_price"
            label="购买总额">
          </el-table-column>
          <el-table-column
            prop="op_time"
            label="下单时间">
          </el-table-column>
          <el-table-column
            label="操作"
            width="80px"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="查看订单详情" placement="top-start">
                <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seeorder(scope.$index, orderdata)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="更改价格" placement="top-start">
                <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="changeprice(scope.$index, orderdata)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="发货" placement="top-start" :hidden="ifhiddentruck">
                <i class="fa fa-truck fa-lg ciicon curpointer" v-on:click="sendorder(scope.$index, orderdata)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="查看物流" placement="top-start" :hidden="ifhiddenqueren || ifhiddenqueren">
                <i class="fa fa-check-circle-o fa-lg ciicon curpointer" v-on:click="lookwl(scope.$index, orderdata)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="确认到货" placement="top-start" :hidden="ifhiddenqueren">
                <i class="fa fa-check-circle-o fa-lg ciicon curpointer" v-on:click="okorder(scope.$index, orderdata)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="作废该订单" placement="top-start">
                <i class="fa fa-trash-o fa-lg curpointer" v-on:click="delorder(scope.$index, orderdata)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="订单详情" :visible.sync="orderdetailvisible">
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="订单编号:">{{curorderno}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="下单日期:">{{curorderdate}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="下单人:">{{curorderbuyuser}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="订单状态:">{{curorderstate}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="24">
            <div class="queryinput">
              <el-form-item label="购买清单:"></el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <div class="showpcinfo" style="margin-top: 10px;">
        <el-table
          stripe
          :header-cell-style="{'text-align':'center'}"
          :data="orderdetaildata"
          ref="multipleTable">
          <el-table-column
            label="图片">
            <template slot-scope="scope">
              <div v-if="scope.row.imgurl.Valid && scope.row.imgurl.String !== ''">
                <img :src="scope.row.imgurl.String" class="goodsavatarimg">
              </div>
              <div v-else>
                {{scope.row.imgurl.String}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="barcode.String"
            label="产品编码">
          </el-table-column>
          <el-table-column
            prop="name.String"
            width = "280px"
            label="商品名称">
          </el-table-column>
          <el-table-column
            prop="gspecname.String"
            label="规格">
          </el-table-column>
          <el-table-column
            prop="price"
            label="单价">
          </el-table-column>
          <el-table-column
            prop="count"
            label="数量">
          </el-table-column>
        </el-table>
      </div>
      <el-row style="flex:1;color: #000; margin-top: 40px;">
        <el-form>
          <el-col :span="24">
            <div class="queryinput">
              <el-form-item label="收货地址:"></el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="收货人姓名:">{{shname}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="联系方式:">{{shcontact}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="所属省市:">{{shssaddress}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="邮编:">{{shzipcode}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="24">
            <div class="queryinput">
              <el-form-item label="详细地址:">{{shaddressex}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
    </el-dialog>
    <el-dialog title="订单详情" :visible.sync="ordershvisible">
      <div class="showpcinfo">
        <el-table
          stripe
          :data="ordershdata"
          ref="multipleTable">
          <el-table-column
            prop="username.String"
            width = "280px"
            label="收货人">
          </el-table-column>
          <el-table-column
            prop="shengname.String"
            label="省">
          </el-table-column>
          <el-table-column
            prop="shiname.String"
            label="市">
          </el-table-column>
          <el-table-column
            prop="address.String"
            label="收货地址">
          </el-table-column>
          <el-table-column
            prop="contact.String"
            label="联系方式">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog title="物流发货" :visible.sync="wuliuvisible">
      <div class="showpcinfo">
        <el-form  label-width="120px">
          <el-row class="querypanel">
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="订单编号:">
                  <el-input v-model="ddno" placeholder="请输入标题"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left" style="margin-left: 20px;">
                <el-form-item label="物流公司选择:">
                  <el-select v-model="wuliuinfo" filterable placeholder="请选择物流公司" >
                    <el-option
                      v-for="item in wuliulist"
                      :key="item.id.Int64"
                      :label="item.lname"
                      :value="item.id.Int64"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="物流单号:" >
                  <el-input v-model="wlno" placeholder="请输入物流单号"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="物流费用(元):" style="margin-left: 20px;">
                  <el-input v-model="wlprice" placeholder="请输入物流费用"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-button style="margin-top: 20px" @click="savekdinfo">发货</el-button>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="物流信息" :visible.sync="wlddvisiable">
      <div class="showpcinfo">
        <el-table
          stripe
          :data="wuliuorder"
          ref="multipleTable">
          <el-table-column
            prop="orderno"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="threename.String"
            label="三方物流名称">
          </el-table-column>
          <el-table-column
            prop="logisticsno.String"
            label="物流单号">
          </el-table-column>
          <el-table-column
            prop="address.String"
            label="费用">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
import ElForm from '../../../node_modules/element-ui/packages/form/src/form'
import ElFormItem from '../../../node_modules/element-ui/packages/form/src/form-item'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
Vue.prototype.$http = axios
var that
export default {
  components: {
    ElFormItem,
    ElForm},
  name: 'FxOrder',
  data () {
    return {
      curorderno: '',
      curorderdate: '',
      curorderbuyuser: '',
      wxuserphone: '',
      activeNames: ['1'],
      activeName: 'orderview',
      wlddvisiable: false,
      curorderstate: '',
      wxuseropenid: '',
      currentPage: 1,
      curpage: 1,
      size: 20,
      total: 0,
      shzipcode: '',
      shname: '',
      shcontact: '',
      shssaddress: '',
      shaddressex: '',
      orderdata: [],
      ordershdata: [],
      byorderdate: '',
      orderdetaildata: [],
      buyuserid: '',
      xfcount: '',
      viplevels: '',
      automlevel: '0',
      wuliuorder: [],
      wxuserlist: [],
      ifhiddentruck: true,
      ifhiddenqueren: true,
      wuliuvisible: false,
      ddno: '',
      wlno: '',
      wlprice: '',
      ordertypelist: [{
        value: 0,
        label: '所有订单'
      }, {
        value: 1,
        label: '销售订单'
      }, {
        value: 4,
        label: '采购订单'
      }],
      ordertype: '',
      orderstate: '',
      orderdetailvisible: false,
      ordershvisible: false,
      wuliulist: [],
      wuliuinfo: '',
      orderstatelist: [{
        value: 0,
        label: '所有状态'
      }, {
        value: 1,
        label: '待付款'
      }, {
        value: 2,
        label: '已付款待发货'
      }, {
        value: 3,
        label: '已发货待确认'
      }, {
        value: 4,
        label: '已完成'
      }, {
        value: 5,
        label: '已评价'
      }, {
        value: 6,
        label: '已分账'
      }]
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
    } else {
      var qstr1 = 'cusid = ' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/gotl',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.wuliulist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    getwxuser (e) {
      window.console.log(e)
      var qsubstr = " LENGTH(openid) = 28 and phone like '%" + e + "%'"
      var sqstr = {
        whereinfo: qsubstr,
        limit: '',
        sortinfo: ''
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querywxuser',
        method: 'post',
        data: sqstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.wxuserlist = res.data
          } else {
            that.wxuserlist = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    curpagehange (val) {
      that.queryrecpage(parseInt(val) - 1)
    },
    queryall () {
      this.queryorder()
      this.queryreccount()
      this.queryorderdesc()
    },
    queryorderdesc () {
      console.log('订单状态发生改变')
      if (this.orderstate === 2) {
        this.ifhiddentruck = false
        this.ifhiddenqueren = true
      } else if (this.orderstate === 3) {
        this.ifhiddentruck = true
        this.ifhiddenqueren = false
      } else {
        this.ifhiddentruck = true
        this.ifhiddenqueren = true
      }
      var qstr = ' type_id=3'
      if (this.orderstate !== null && this.orderstate !== '' && this.orderstate !== 0) {
        qstr = qstr + ' and state_id=' + this.orderstate
      }
      if (this.byorderdate !== null && this.byorderdate !== '') {
        qstr = qstr + " and op_time >= '" + this.byorderdate[0] + " 00:00:00' and op_time<='" + this.byorderdate[1] + " 23:59:59'"
      }
      if (this.wxuseropenid !== null && this.wxuseropenid !== '' && this.wxuseropenid !== 0) {
        qstr = qstr + " and cus_id = '" + this.wxuseropenid + "'"
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorder',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: ' limit 0,' + that.size,
          sortinfo: ' order by op_time desc'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            window.console.log(res.data)
            that.orderdata = res.data
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryreccount () {
      var qstr = ' type_id=3'
      if (this.orderstate !== null && this.orderstate !== '' && this.orderstate !== 0) {
        qstr = qstr + ' and state_id=' + this.orderstate
      }
      if (this.byorderdate !== null && this.byorderdate !== '') {
        qstr = qstr + " and op_time >= '" + this.byorderdate[0] + " 00:00:00' and op_time<='" + this.byorderdate[1] + " 23:59:59'"
      }
      if (this.wxuseropenid !== null && this.wxuseropenid !== '' && this.wxuseropenid !== 0) {
        qstr = qstr + " and cus_id = '" + this.wxuseropenid + "'"
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryordercount',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ' order by op_time desc'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.total = res.data[0].count
          } else {
            that.total = 0
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryrecpage (val) {
      if (this.orderstate === 2) {
        this.ifhiddentruck = false
        this.ifhiddenqueren = true
      } else if (this.orderstate === 3) {
        this.ifhiddentruck = true
        this.ifhiddenqueren = false
      } else {
        this.ifhiddentruck = true
        this.ifhiddenqueren = true
      }
      var qstr = ' type_id=3'
      if (this.orderstate !== null && this.orderstate !== '' && this.orderstate !== 0) {
        qstr = qstr + ' and state_id=' + this.orderstate
      }
      if (this.byorderdate !== null && this.byorderdate !== '') {
        qstr = qstr + " and op_time >= '" + this.byorderdate[0] + " 00:00:00' and op_time<='" + this.byorderdate[1] + " 23:59:59'"
      }
      if (this.wxuseropenid !== null && this.wxuseropenid !== '' && this.wxuseropenid !== 0) {
        qstr = qstr + " and cus_id = '" + this.wxuseropenid + "'"
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorder',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: ' limit ' + val*that.size + ',' + that.size,
          sortinfo: ' order by op_time desc'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            window.console.log(res.data)
            that.orderdata = res.data
          } else {
            that.orderdata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryorder () {
      console.log('订单状态发生改变')
      if (this.orderstate === 2) {
        this.ifhiddentruck = false
        this.ifhiddenqueren = true
      } else if (this.orderstate === 3) {
        this.ifhiddentruck = true
        this.ifhiddenqueren = false
      } else {
        this.ifhiddentruck = true
        this.ifhiddenqueren = true
      }
      var qstr = ' type_id=3'
      if (this.orderstate !== null && this.orderstate !== '' && this.orderstate !== 0) {
        qstr = qstr + ' and state_id=' + this.orderstate
      }
      if (this.byorderdate !== null && this.byorderdate !== '') {
        qstr = qstr + " and op_time >= '" + this.byorderdate[0] + " 00:00:00' and op_time<='" + this.byorderdate[1] + " 23:59:59'"
      }
      if (this.wxuseropenid !== null && this.wxuseropenid !== '' && this.wxuseropenid !== 0) {
        qstr = qstr + " and cus_id = '" + this.wxuseropenid + "'"
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorder',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: ' limit 0,' + that.size,
          sortinfo: ' order by op_time desc'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.drawLine(res.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    changeprice (index, data) {
      var pricedata = data[index]
      console.log(pricedata)
      this.$prompt('请输入新的价格', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        var qstr = "order_no ='" + pricedata.orderno + "'"
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/upboi',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            fieldparams: {String: ' count_price=' + value, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '已更新订单价格!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消价格变更'
        })
      })
    },
    drawLine (tmpdata) {
      var xdata = []
      var ydata = []
      for (var i = 0; i < tmpdata.length; i++) {
        xdata.push(tmpdata[i].op_time)
        ydata.push(tmpdata[i].count_price)
      }
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById('mymainChart'))
      // 绘制图表
      myChart.setOption({
        legend: {
          data: ['业绩金额']
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xdata
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: ydata,
          type: 'line'
        }]
      })
      window.onresize = myChart.resize
    },
    printorder () {},
    seeordersh (index, data) {
      console.log(data[index])
      this.ordershvisible = true
    },
    seeorder (index, data) {
      var ddata = data[index]
      console.log(ddata)
      this.curorderno = ddata.orderno
      this.curorderdate = ddata.optime
      this.curorderbuyuser = ddata.name.String
      this.curorderstate = this.orderstatelist[ddata.stateid].label
      this.orderdetailvisible = true
      var qstr = "order_no ='" + ddata.orderno + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/god',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.orderdetaildata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      var qstr1 = "orderno ='" + ddata.orderno + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/getbuae',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.data !== '[]') {
              console.log(JSON.parse(res.data.data))
              var tmpdata = JSON.parse(res.data.data)[0]
              that.shzipcode = tmpdata.zipcode.String
              that.shname = tmpdata.username.String
              that.shcontact = tmpdata.contact.String
              that.shssaddress = tmpdata.ssaddress.String
              that.shaddressex = tmpdata.address.String
            } else {
              that.shzipcode = ''
              that.shname = ''
              that.shcontact = ''
              that.shssaddress = ''
              that.shaddressex = ''
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    delorder (index, data) {
      console.log(data[index])
      var ddata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/doi',
        method: 'post',
        data: {
          orderno: ddata.orderno
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            data.splice(index, 1)
            that.orderdata.splice(index, 1)
            that.$message({
              type: 'success',
              message: '已删除订单信息!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    orderstatechange () {
    },
    ordertypechange () {},
    sendorder (index, data) {
      this.wuliuvisible = true
      this.ddno = data[index].orderno
      this.buyuserid = data[index].buycusid
      console.log(this.wuliulist)
    },
    okorder (index, data) {
      this.ddno = data[index].orderno
      this.$confirm('确定对订单 "' + this.ddno + '"进行确认收货吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        var qstr = "order_no ='" + that.ddno + "'"
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/upboi',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            fieldparams: {String: ' state_id=4', Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '已更新订单状态!'
              })
              if (that.orderstate === 2) {
                that.ifhiddentruck = false
                that.ifhiddenqueren = true
              } else if (that.orderstate === 3) {
                that.ifhiddentruck = true
                that.ifhiddenqueren = false
              } else {
                that.ifhiddentruck = true
                that.ifhiddenqueren = true
              }
              var qstr = 'type_id != 2 and type_id != 3 and sale_cus_id =' + that.khid
              if (that.ordertype !== null && that.ordertype !== '' && that.ordertype !== '0') {
                qstr = qstr + ' and type_id=' + that.ordertype
              }
              if (that.orderstate !== null && that.orderstate !== '' && that.orderstate !== '0') {
                qstr = qstr + ' and state_id=' + that.orderstate
              }
              if (that.byorderdate !== null && that.byorderdate !== '') {
                qstr = qstr + " and op_time >= '" + that.byorderdate[0] + " 00:00:00' and op_time<='" + that.byorderdate[1] + " 23:59:59'"
              }
              that.$http({
                url: 'https://api.sqnetsoft.cn/order/goi',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true},
                  sorinfo: {String: ' order by op_time desc', Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.orderdata = JSON.parse(res.data.data)
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
              console.log(JSON.parse(res.data.data))
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      })
    },
    savekdinfo () {
      console.log(this.ddno)
      console.log(this.wlno)
      console.log(this.wlprice)
      console.log(this.wuliuinfo)
      var wldata = {
        orderno: this.ddno,
        logisticsno: {String: this.wlno, Valid: true},
        threeid: {Int64: parseInt(this.wuliuinfo), Valid: true},
        price: {String: this.wlprice, Valid: true},
        cusid: parseInt(that.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/aaubol',
        method: 'post',
        data: wldata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '物流信息保存完毕!'
            })
            console.log(JSON.parse(res.data.data))
            console.log('更新订单状态')
            var qstr = "order_no ='" + that.ddno + "'"
            that.$http({
              url: 'https://api.sqnetsoft.cn/order/upboi',
              method: 'post',
              data: {
                whereinfo: {String: qstr, Valid: true},
                fieldparams: {String: ' state_id=3', Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.wuliuvisible = false
                  console.log(JSON.parse(res.data.data))
                  if (that.orderstate === 2) {
                    that.ifhiddentruck = false
                    that.ifhiddenqueren = true
                  } else if (that.orderstate === 3) {
                    that.ifhiddentruck = true
                    that.ifhiddenqueren = false
                  } else {
                    that.ifhiddentruck = true
                    that.ifhiddenqueren = true
                  }
                  var qstr = 'type_id != 2 and type_id != 3 and sale_cus_id =' + that.khid
                  if (that.ordertype !== null && that.ordertype !== '' && that.ordertype !== '0') {
                    qstr = qstr + ' and type_id=' + that.ordertype
                  }
                  if (that.orderstate !== null && that.orderstate !== '' && that.orderstate !== '0') {
                    qstr = qstr + ' and state_id=' + that.orderstate
                  }
                  if (that.byorderdate !== null && that.byorderdate !== '') {
                    qstr = qstr + " and op_time >= '" + that.byorderdate[0] + " 00:00:00' and op_time<='" + that.byorderdate[1] + " 23:59:59'"
                  }
                  that.$http({
                    url: 'https://api.sqnetsoft.cn/order/goi',
                    method: 'post',
                    data: {
                      whereinfo: {String: qstr, Valid: true},
                      sorinfo: {String: ' order by op_time desc', Valid: true}
                    },
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  })
                    .then(function (res) {
                      if (res.data.success) {
                        console.log(JSON.parse(res.data.data))
                        that.orderdata = JSON.parse(res.data.data)
                      }
                    })
                    .catch(function (error) {
                      console.log('error' + error)
                    })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      // 处理会员数据
      console.log('处理会员数据')
      // 获取会员ID
      console.log(this.buyuserid)
      // 获取用户会员是否自动计费
      var qstr = "userid ='" + this.buyuserid + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/cardticket/getbmac',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success && res.data.data !== '[]') {
            var data = JSON.parse(res.data.data)
            if (data[0].ifautocard === 1) {
              console.log('自动会员计费')
              var qstr = 'buy_cus_id  = ' + that.buyuserid + ' and sale_cus_id= ' + that.khid + ' and state_id > 1'
              that.$http({
                url: 'https://api.sqnetsoft.cn/order/goc',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.xfcount = JSON.parse(res.data.data)
                    console.log('根据用户消费金额设定用户等级')
                    var qstr1 = 'cusid  = ' + that.khid
                    that.$http({
                      url: 'https://api.sqnetsoft.cn/cardticket/getbcl',
                      method: 'post',
                      data: {
                        whereinfo: {String: qstr1, Valid: true}
                      },
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    })
                      .then(function (res) {
                        if (res.data.success) {
                          console.log(JSON.parse(res.data.data))
                          that.viplevels = JSON.parse(res.data.data)
                          console.log('根据用户消费金额设定用户等级')
                          that.automlevel = -1
                          for (var i = 0; i < that.viplevels.length; i++) {
                            if (that.xfcount < that.viplevels[i].count) {
                              console.log(i)
                              console.log(that.xfcount)
                              console.log(that.viplevels[i].count)
                              if (i === 0) {
                                that.automlevel = 0
                              } else {
                                that.automlevel = that.viplevels[i].level - 1
                              }
                              break
                            }
                          }
                          if (that.automlevel === -1) {
                            that.automlevel = that.viplevels[that.viplevels.length - 1].level
                          }
                          console.log('当前级别：')
                          console.log(that.automlevel)
                          var whereinfo = ' userid = ' + that.buyuserid
                          var fieldparams = ' buycount=' + that.xfcount + ',levelid=' + that.automlevel
                          that.$http({
                            url: 'https://api.sqnetsoft.cn/cardticket/upbmc',
                            method: 'post',
                            data: {
                              fieldparams: {String: fieldparams, Valid: true},
                              whereinfo: {String: whereinfo, Valid: true}
                            },
                            headers: {
                              'Content-Type': 'application/json'
                            }
                          })
                            .then(function (res) {
                              if (res.data.success) {
                                that.$message({
                                  type: 'success',
                                  message: '已自动更新卡等级!'
                                })
                              }
                            })
                            .catch(function (error) {
                              console.log('error' + error)
                            })
                        }
                      })
                      .catch(function (error) {
                        console.log('error' + error)
                      })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            } else {
              console.log('手动计费')
            }
          } else {
            console.log('找不到会员信息')
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    lookwl (index, data) {
      this.wlddvisiable = true
      this.ddno = data[index].orderno
      var qstr = "orderno ='" + this.ddno + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/getbol',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            if (res.data.data === '[]') {
              that.wuliuorder = ''
            } else {
              that.wuliuorder = JSON.parse(res.data.data)
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    outputorder () {
      // 表名
      var wb = XLSX.utils.table_to_book(document.querySelector('#fxorderdataid'))
      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'order.xlsx')
      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
      return wbout
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>
<style>
  .card {
    height: 500px;
    width: 100%;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/FXOrder.vue